import { StatusPanel } from '@tencent/tpm-trtc-console';
import { t } from '@src/utils/translate';

export function Banned({}) {
  return (
    <div style={{margin: '30px auto'}}>
      <StatusPanel status="error" title={t("Access Error 007, Service Temporarily Unavailable.")} />
    </div>
  );
}
